var map = {
	"./avatars/avatar": 35,
	"./avatars/avatar-3": 36,
	"./avatars/avatar-3.png": 36,
	"./avatars/avatar.jpg": 35,
	"./errors-images/404-error": 37,
	"./errors-images/404-error.png": 37,
	"./errors-images/505-error": 38,
	"./errors-images/505-error.png": 38,
	"./lexiqamus-logo": 39,
	"./lexiqamus-logo.png": 39,
	"./lexiqamus-sidebar-logo": 40,
	"./lexiqamus-sidebar-logo.png": 40,
	"./lexiqamus/ekual-announcement-megaphone": 18,
	"./lexiqamus/ekual-announcement-megaphone.svg": 18,
	"./lexiqamus/innovation_announcements/hareket1": 19,
	"./lexiqamus/innovation_announcements/hareket1.jpg": 19,
	"./lexiqamus/innovation_announcements/hareket2": 20,
	"./lexiqamus/innovation_announcements/hareket2.jpg": 20,
	"./lexiqamus/innovation_announcements/hareket3": 21,
	"./lexiqamus/innovation_announcements/hareket3.jpg": 21,
	"./lexiqamus/innovation_announcements/hareket4": 22,
	"./lexiqamus/innovation_announcements/hareket4.jpg": 22,
	"./lexiqamus/innovation_announcements/original-document": 23,
	"./lexiqamus/innovation_announcements/original-document.png": 23,
	"./lexiqamus/innovation_announcements/smart-results": 24,
	"./lexiqamus/innovation_announcements/smart-results.png": 24,
	"./lexiqamus/landing/hareket1": 41,
	"./lexiqamus/landing/hareket1.jpg": 41,
	"./lexiqamus/landing/hareket2": 42,
	"./lexiqamus/landing/hareket2.jpg": 42,
	"./lexiqamus/landing/hareket3": 43,
	"./lexiqamus/landing/hareket3.jpg": 43,
	"./lexiqamus/landing/hareket4": 44,
	"./lexiqamus/landing/hareket4.jpg": 44,
	"./lexiqamus/landing/original-document": 45,
	"./lexiqamus/landing/original-document.png": 45,
	"./lexiqamus/landing/smart-results": 46,
	"./lexiqamus/landing/smart-results.png": 46,
	"./logo-icon": 47,
	"./logo-icon.png": 47,
	"./lq-logo": 48,
	"./lq-logo.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;